import styled from 'styled-components';
import colors from '../../styles/theme/colors';
import { sizes } from '../../styles/theme/devices';
import spaces from '../../styles/theme/spaces';

const Container = styled.footer`
  align-items: center;
  background-color: ${colors.default.white};
  bottom: 0;
  box-shadow: 0 4px 30px 0 ${colors.default.black05};
  display: flex;
  justify-content: center;
  padding-top: ${spaces.extraSmall};
  position: fixed;
  width: 100%;
  z-index: 2;

  @media (min-width: ${sizes.tablet}) {
    margin-top: ${spaces.small};
  }
`;

const Action = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
  margin: 0;
  max-width: ${sizes.tablet};
  padding: calc(${spaces.xs} / 2);

  @media (min-width: ${sizes.tablet}) {
    flex-direction: row;
    padding: ${spaces.xs} ${spaces.small};
  }

  .MuiButton-root {
    margin: 0;
  }

  button {
    background-color: ${colors.secondary.main};
    border-radius: 8px;

    & > p {
      margin-left: 3px;
    }

    div,
    p {
      font-size: 16px;
      font-weight: 500;
    }

    svg {
      height: 26px;
      margin: 0 0 0 8px;
      width: 26px;
    }

    &.outline {
      background-color: unset;
      border: 2px solid ${colors.secondary.main};
      margin-top: ${spaces.xs};

      @media (min-width: ${sizes.tablet}) {
        margin-right: ${spaces.xs};
        margin-top: 0;
      }
    }
  }
`;


export { Action, Container };
